import { Box, Typography } from '@mui/material'
import ImageBanner from 'components/image-banner'
import LogoTheme from 'components/logo-theme'
import LoginGirlSVG from 'components/svg/login-girl'
import WrapperPermission from 'components/wrapper-permission'
import { useAuth } from 'contexts/auth'
import { IOrganizationUserDTO } from 'data/dtos/authentication/i-organization-user-dto'
import { useEffect, useState } from 'react'
import api from 'services/api'
import { formatCNPJ } from 'utils/is-valid-cnpj'
import OrganizationOptions from '../organization-options'
import { useStyles } from './styles'

const ListMultipleOrganizaTions = () => {
  const [organizationsByUser, setOrganizationsByUser] = useState<IOrganizationUserDTO[]>([])
  const { changeOrganization } = useAuth()
  const classes = useStyles()

  const getOrganizationsByUser = async () => {
    try {
      const { data } = await api.get('/organizations-users/find-organization-by-user-id')

      setOrganizationsByUser(data.data)
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    getOrganizationsByUser()
  }, [])

  return (
    <Box className={classes.container}>
      <Box className={classes.mainWrapper}>
        <WrapperPermission>
          <Box className={classes.formBox}>
            <LogoTheme />
            <Box className={classes.textContainer}>
              <Typography className={classes.formTitle}>Escolha a organização que deseja operar</Typography>
              <Typography className={classes.formDescription}>
                Selecione uma organização para acessar a plataforma
              </Typography>
            </Box>

            <Box className={classes.authorizationBox}>
              {organizationsByUser.map((orgs, index) => {
                const organizationType = orgs.organizationType?.name || ''
                const isSeller = organizationType.toLowerCase().includes('seller')

                // For Seller/Corretora: only show eSocial chip if certificate is required
                // For others (Buyer/RH): show eSocial chip based on normal logic
                const showESocialChip = isSeller ? orgs.certificateRequired : true
                const eSocialStatus = !orgs.certificateRequired || (orgs.certificateUploadDate && orgs.certificateUploadDate?.length > 0 ? true : false)

                return (
                  <OrganizationOptions
                    key={index}
                    organizationType={organizationType}
                    eSocialStatus={eSocialStatus}
                    showESocialChip={showESocialChip}
                    organizationName={orgs.corporateName}
                    federalTaxId={formatCNPJ(orgs.federalTaxId as string)}
                    handleChoseOrg={() => changeOrganization(orgs.id)}
                  />
                )
              })}
            </Box>
          </Box>
        </WrapperPermission>
        <ImageBanner
          title='Agora você está conectado ao seu corretor, o que agilizará os processos com mais segurança e tranquilidade para sua empresa.'
          banner={<LoginGirlSVG />}
        />
      </Box>
    </Box>
  )
}

export default ListMultipleOrganizaTions
